module.exports = __webpack_public_path__ + "static/browse1-8f6761e969d2cca502caf78fa9242fcc.png";